import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=0159dd88&lang=less&scoped=true"

import exportComponent from "D:\\liang_front_end\\payment-system-admin-yuyooke\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0159dd88"]])

export default __exports__